import Button from "@/components/bricks/button/Button";
import AlertRoot, { Alert } from "../Alert/Alert";
import { useConfirm } from "./useConfirm";
import { createPortal } from "react-dom";

export function ConfirmDialog() {
  const { onConfirm, onCancel, confirmState } = useConfirm();

  const portalElement = document.getElementById("portal");
  const component = (
    <AlertRoot open={confirmState.show} setOpen={() => {}}>
      <Alert
        title={confirmState.title}
        description={confirmState.description}
        cancelButton={
          confirmState.cancelBtnText && (
            <Button color="secondary" onClick={onCancel}>
              {confirmState.cancelBtnText}
            </Button>
          )
        }
        actionButton={
          confirmState.confirmBtnText && (
            <Button onClick={onConfirm}>{confirmState.confirmBtnText}</Button>
          )
        }
      />
    </AlertRoot>
  );

  return createPortal(component, portalElement ?? document.body);
}
